import React from 'react';

const DashboardCardDesc = ({ children }) => <p className="dashboardCard-desc">{children}</p>;

export default DashboardCardDesc;
